<template>
  <div
    class="preflop-shortcut solfigrshrtcts"
    :class="{ gw_loading: loading }"
  >
    <slot></slot>
    <div class="f-column f-center position-relative w-100">
      <StudyMessageOverlay
        v-if="!ch_actions.hasContent && !gameformat.subscription_tier"
        style="
          z-index: 2;
          --back-from: var(--clr-black-1);
          --back-to: var(--clr-black-1);
          --box-shadow: none;
          height: 100%;
        "
        :messages="['403_only_subscribed']"
        :canAISolve="false"
        :namespace="namespace"
        :street="'preflop'"
        :pageKey="'solutions'"
      />
      <div class="solfigrshrtcts_table-container">
        <!-- --table-hor-min-width: 100%; -->
        <PokerTableShortcuts
          :class="{ 'no-events': loading }"
          :style="`
      --table-hor-height: 18em;
      --table-hor-min-height: 18em;
      --table-hor-min-width: 36em;
      --table-hor-max-width: 36em;
      --table-width: 38em;
      --table-ver-max-width: 32em;
      --table-ver-max-height: 42em;
      --clr-hero: var(--clr-hero-default);
      --clr-trainer_player_active: var(--clr-black-3);
      --clr-trainer_player_folded: var(--clr-black-1-2);
      --clr-table-back: var(--clr-black-0-4);
      font-size: 0.875rem;
  `"
          :players="tablePlayers"
          :hasStack="showHistory"
          :hasCards="showHistory"
          :asCheckbox="!showHistory"
          :potVisible="showHistory"
          :spot="hSpot"
          class="text-noselect solfigrshrtcts_poker-table"
          @click:player="toggleTablePlayer"
        />
      </div>

      <div class="f-column f-center">
        <!-- TODO: add i18n -->
        <div
          v-if="$store.getters.user_has_flag('SOL_3WAY') && ch_actions.hasContent"
          class="f-column"
          :style="actionSelector === 'Auto' ? 'align-self: flex-start' : 'align-self: center'"
        >
          <GwTitleTooltip
            title="Action selector"
            style="margin: 0 0 0.25rem 0"
          />
          <GwBtns
            :options="['Auto', 'Custom']"
            class="gwbtns_horizontal_grey solfigrtp_top_btns gw_loading_text"
            :value="actionSelector"
            style="
              margin-bottom: 1rem;
              border-radius: 4px;
              align-self: flex-start;
              background: var(--clr-black-1-3);
              --gwbtn-clr-back: var(--clr-black-1-3);
              --gwbtn-clr-active-white: var(--clr-black-3);
              --gwbtn-size: 1rem;
              --gwbtn-height: 1.875rem;
              --gwbtns-padding: 2px;
            "
            tstPrefix="solfigr_prefill_action_selector"
            @click="
              (_e, item) => {
                actionSelector = item
              }
            "
          >
            <template #default="{ item }">
              {{ item }}
            </template>
          </GwBtns>
        </div>

        <CheckboxRow
          v-if="
            $store.getters.user_has_flag('SOL_3WAY')
              ? actionSelector === 'Auto' &&
                (ch_actions.hasContent || !gameformat.subscription_tier)
              : ch_actions.hasContent || !gameformat.subscription_tier
          "
          class="prfshrts_checkbox-row gw_loading_texts"
          style="--clr-row-back: var(--clr-black-1-3)"
          :hasTitle="true"
          :hasAny="false"
          :isSingle="true"
          :hasContent="ch_actions.hasContent"
          :item="ch_actions"
          :loading="loading"
          @update="item => setAction(item)"
        >
          <template #default="v">
            {{ $t(`shortcut.${v.id}`) }}
          </template>
          <template #after>
            <div
              v-if="!ch_actions.hasContent"
              class="px-2 py-1 clr-yellow b-radius_4 f-center text-medium"
              style="background-color: rgba(255, 184, 0, 0.1)"
            >
              <i class="mdi mdi-information-outline mr-2 mb-auto"></i>
              <span v-html="$t(`messages.solution_no_shortcuts_solfigr`)"> </span>
            </div>
          </template>
        </CheckboxRow>

        <!-- {{ namespace }} -->
        <div
          v-else-if="showHistory"
          class="mt-2 f-column f-center"
          style="min-width: 0; width: clamp(1px, 38rem, calc(100vw - 4em))"
        >
          <div class="clr-grey text-normal weight_500">
            {{ $t('messages.choose_last_flop_node_to_prefill_ranges') }}
          </div>

          <PokerHistoryEvents
            class="mt-4"
            :namespace="namespace"
            :canAISolve="false"
            :hasFlopSolutionEndNode="true"
            :clickableFlopSolutionEndNode="false"
            :actionEmitOnly="false"
            :hasNodeEdit="false"
            :hasMinimized="false"
            :hasInitialLoad="false"
            :hasGameformat="false"
            :stopOnEndOfStreet="'preflop'"
            :hasShortcuts="false"
            :hasWatcherEnabled="false"
            :clickableBoard="false"
            :hasEmptyBoard="true"
            :hasTurnPreload="false"
            :openToTop="true"
            :hasGGSaveSpot="false"
            :routerParams="{
              push: false,
              replace: false,
              saveLocally: false,
            }"
            style="--clr-hs-back: var(--clr-black-2); --hs-spot-clr-border: var(--clr-black-2)"
          >
            <template #solution_end_message>
              <div class="clr-grey f-column f-center">
                <div
                  class="clr-grey text-normal weight_500 text-center"
                  style="max-width: 9rem"
                >
                  {{ $t(`messages.solution_prefill_from_this_node`) }}
                </div>
                <div class="mdi mdi-chevron-double-down clr-grey text-semi-large mt-1"></div>
              </div>
            </template>
          </PokerHistoryEvents>
        </div>
        <!-- @click:action="handleUpdateHsAction" -->
      </div>
    </div>

    <portal to="dialog_actions">
      <v-btn
        data-tst="btn_shortcut_apply"
        color="primary"
        :disabled="!canApply"
        @click="$emit('click:apply')"
      >
        {{ $t('btn.confirm') }}
      </v-btn>
    </portal>
  </div>
</template>

<script>
import PokerHistoryEvents from '@/components/Poker/PokerHistoryEvents/PokerHistoryEvents'
import { getRandomOption } from '@/helpers/helpers'
import { getPlayersDefault } from '@/store/gamestate/gamestate'
import {
  getAvailableGames,
  getAvailableShortcuts,
  getShortcutsPositions,
  getShortcutsActionOptions,
} from '@/helpers/practice_trainer'
import PokerTableShortcuts from '@/components/PokerTable/PokerTableShortcuts'
import CheckboxRow from '@/components/Forms/CheckboxRow'
import StudyMessageOverlay from '@/components/Poker/Overlays/StudyMessageOverlay'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import GwBtns from '@/components/lib/GwBtns'

export default {
  name: 'SolfigrGmfShortcut',
  components: {
    PokerTableShortcuts,
    StudyMessageOverlay,
    CheckboxRow,
    PokerHistoryEvents,
    GwTitleTooltip,
    GwBtns,
  },
  props: {
    namespace: { required: true },
    instaUpdateShortcut: { type: Boolean, default: true },
    gameformat: Object,
    startSpot: { default: () => 'flop' },
    shortcut: {
      type: Object,
      default: () => ({
        one: '',
        two: '',
        action: '',
      }),
    },
  },
  emits: ['click:apply', 'update:shortcut'],
  data() {
    return {
      l_action: '',
      l_player_one: '',
      l_player_two: '',
      l_startSpot: 'flop',
      actionSelector: 'Auto',
    }
  },
  methods: {
    getHistorySpots() {
      const routerParams = {
        push: false,
        replace: false,
        saveLocally: false,
      }
      this.$store.dispatch(`${this.namespace}/gamestate_reset_history`, {
        routerParams,
      })
      this.$store.dispatch('api_poker_history', {
        namespace: this.namespace,
        routerParams,
      })
    },
    getApiShortcuts() {
      this.$store.dispatch('api_poker_shortcuts', {
        namespace: this.namespace,
        hasDepthList: false,
      })
    },
    setAction(val, initial = false) {
      // console.log(val)
      const id = val.selected[0]
      this.l_action = id
      if (this.instaUpdateShortcut && !initial) {
        this.updateShortcut()
      }
    },
    toggleTablePlayer(player) {
      if (this.showHistory) return
      if (this.allPokerPositions.length === 2) return

      // console.log(this.available.positions);

      const { position } = player
      let l_positions = [this.l_player_one, this.l_player_two]

      if (l_positions.includes(position)) {
        l_positions = l_positions.filter(p => p !== position)
      } else {
        l_positions = [position, ...l_positions]
      }

      l_positions = l_positions.filter(p => p)
      l_positions = [...new Set(l_positions)]

      if (l_positions.length === 3) {
        l_positions = l_positions.splice(0, 2)
      }
      if (l_positions.length === 1) {
        const rp = getRandomOption({ options: this.allPokerPositions, selected: [l_positions[0]] })
        l_positions = [...l_positions, rp]
      }

      this.l_player_one = l_positions[0]
      this.l_player_two = l_positions[1]

      if (this.instaUpdateShortcut) {
        this.updateShortcut()
      }
    },

    initialize() {
      if (this.loading) return
      if (!this.ch_actions?.hasContent) return

      const player_one = this.allPokerPositions.includes(this.shortcut?.player_one)
        ? this.shortcut?.player_one
        : this.allPokerPositions[0]

      const player_two = this.allPokerPositions.includes(this.shortcut?.player_two)
        ? this.shortcut?.player_two
        : this.allPokerPositions[1]

      const action = this.available.actions.includes(this.shortcut?.action)
        ? this.shortcut?.action
        : this.available.actions[0]

      this.l_player_one = player_one
      this.l_player_two = player_two
      this.l_action = action
      // this.setAction({ selected: [action] }, true)

      if (this.instaUpdateShortcut && this.loaded) {
        this.updateShortcut()
      }
    },
    updateShortcut() {
      const apiShortcut = this.apiShortcuts.find(
        i =>
          i.label.street === 'FLOP' &&
          i.label.type === this.l_action &&
          i.label.positions.includes(this.l_player_one) &&
          i.label.positions.includes(this.l_player_two),
      )
      if (!apiShortcut) {
        console.log('no apiShortcut')
      }
      const res = {
        player_one: this.l_player_one,
        player_two: this.l_player_two,
        action: this.l_action,
        gameformat: this.gameformat,
        label_id: apiShortcut?.label.id,
        apiShortcut,
      }
      // console.log('updateShortcut', res)
      this.$emit('update:shortcut', res)
    },
    emptyShortuct() {
      this.$emit('update:shortcut', null)
    },
  },
  computed: {
    canApply() {
      if (this.showHistory) {
        const selectedAction = (this.hSpot?.available_actions || []).find(i => i.is_selected)
        // console.log(selectedAction)
        // board is legacy - can be removed after API breaking change action.action
        return selectedAction?.outcome === 'board' || selectedAction?.is_fe_solution_end
      }
      return this.ch_actions.hasContent
    },
    ch_actions() {
      const disabled = this.unavailable.actions
      const selected = [this.l_action]
      const options = this.loading ? [0, 1, 2, 4, 5] : this.all.actions

      const res = {
        id: 'actions_for_shortcut_id',
        title: this.$t('shortcut.street_action', { street: this.$t(`common.preflop`) }),
        options,
        selected,
        disabled,
        hasContent: options.length !== disabled.length,
      }
      return res
    },
    hSpot() {
      return this.$store.getters[`${this.namespace}/history_spot`]
    },
    tablePlayers() {
      if (this.showHistory) {
        return this.hSpot?.players || getPlayersDefault({ gameformat: this.gameformat })
      }
      const style = { '--clr-player-back-folded': 'var(--clr-black-1)' }
      const hoverStyle = { '--clr-player-primary': 'var(--clr-primary)' }

      const res = this.allPlayers.map(p => {
        const asCheckbox = true

        const { position } = p
        const pos = this.allPokerPositions.includes('BTN') ? 'BTN' : 'SB'
        const is_dealer = position === pos

        const is_folded = this.unavailable.positions.includes(position)
        const css_class = is_folded ? 'no-events' : ''

        let checked = [this.l_player_one, this.l_player_two].some(plp => plp === position)
        checked = !is_folded && checked

        const r = {
          ...p,
          position,
          asCheckbox,
          is_folded,
          is_active: checked,
          is_dealer,
          checked,
          css_class,
          style: checked ? style : hoverStyle,
        }
        return r
      })
      // console.log(res)
      return res
    },
    all() {
      const apiData = this.apiShortcuts || []
      const shortcuts = getAvailableShortcuts({
        shortcuts: apiData,
        start_spot: this.startSpot,
      })
      const positions = getShortcutsPositions({ shortcuts })
      const actions = getShortcutsActionOptions({ shortcuts })
      const res = {
        shortcuts,
        actions,
        positions,
      }
      // console.log(res)
      return res
    },
    available() {
      const params = {
        heros: [this.l_player_one],
        opponents: [this.l_player_two],
        shortcuts: this.all.shortcuts,
        start_spot: this.startSpot,
      }
      const { shortcuts, actions } = getAvailableGames(params)
      const res = {
        shortcuts,
        actions,
        positions: this.all.positions,
      }
      // console.log(res)
      return res
    },
    unavailable() {
      const positions = this.allPokerPositions.filter(p => !this.available.positions.includes(p))
      const actions = this.all.actions.filter(p => !this.available.actions.includes(p))
      const res = {
        actions,
        positions,
      }
      // console.log(res)
      return res
    },
    allPlayers() {
      const gameformat =
        this.gameformat ||
        this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gameformat`]
      const res = getPlayersDefault({ gameformat })
      return res
    },
    allPokerPositions() {
      return this.allPlayers.map(p => p.position)
    },
    apiCall() {
      return this.$store.getters.api_get('api_poker_shortcuts', this.namespace)
    },
    apiShortcuts() {
      return this.$store.getters.api_get_data('api_poker_shortcuts', this.namespace) || []
    },
    loading() {
      return this.apiCall?.loading
    },
    loaded() {
      return this.apiCall?.loaded
    },
    showHistory() {
      if (this.$store.getters.user_has_flag('SOL_3WAY')) {
        return (
          this.actionSelector === 'Custom' ||
          (!this.ch_actions?.hasContent && !!this.gameformat.subscription_tier)
        )
      }
      return !this.ch_actions?.hasContent && !!this.gameformat.subscription_tier
    },
  },
  watch: {
    gameformat: {
      immediate: true,
      handler: 'getApiShortcuts',
    },
    apiShortcuts: {
      immediate: true,
      handler: 'initialize',
    },
    showHistory() {
      this.$store.commit(`${this.namespace}/gamestate_set`, {
        key: 'history_spots',
        value: [],
      })
      if (this.showHistory) {
        this.emptyShortuct()
        this.getHistorySpots()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.solfigrshrtcts {
  // width: 44em;
  max-width: calc(100vw - 4em);
  padding: 1em 0 1rem 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  &_table-container {
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 1em;
    width: 100%;
    max-width: 100vw;
  }
}
@media (max-width: 1366px) {
  .solfigrshrtcts {
    align-items: center;
  }
}
@media (max-width: 1023px) {
  .solfigrshrtcts {
    &_table-container {
      height: calc(100vh * 0.55);
      flex-shrink: 0;
      display: flex;
      width: 100%;
      max-height: 42em;
      max-width: 100vw;
      .solfigrshrtcts_poker-table {
        min-height: 100% !important;
      }
    }
  }
}
</style>
